/**
 * RTK QueryのReducerはネストできないので、Root Reducerにセットする
 */
export const rtkQueryReducers = {};

export const rtkQueryInitialStates = {};

export const rtkQueryMiddleWares = [];
